const getters = {
  getResult: (state) => state.result,
};

export default getters;
